import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProPlanTeaser: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Don't show if user is not logged in or already has pro plan
  if (!isAuthenticated || !user || user['custom:plan'] === 'pro') {
    return null;
  }
  const features = [
    {
      icon: '📊',
      title: 'Unlimited Quizzes',
      description: 'Create unlimited quizzes for all your needs',
      free: '5 saved quizzes',
      pro: 'Unlimited'
    },
    {
      icon: '👥',
      title: '100 Participants',
      description: 'Host massive quiz sessions with ease',
      free: '10 participants',
      pro: '100 participants'
    },
    {
      icon: '📝',
      title: '20 Questions',
      description: 'More questions per quiz for deeper learning',
      free: '10 questions',
      pro: '20 questions'
    },
    {
      icon: '⚡',
      title: 'Fast Start',
      description: 'Games start in seconds, not minutes',
      free: '~30 seconds',
      pro: '10-15 seconds'
    }
  ];

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-8 my-16">
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-2 mb-4">
          <span className="text-2xl">🚀</span>
          <span className="text-sm font-semibold text-orange-600 uppercase tracking-wide">Upgrade to Pro</span>
        </div>
        <h2 className="text-3xl font-bold text-gray-900 mb-2">
          Supercharge Your Quiz Experience
        </h2>
        <p className="text-gray-600 text-base">
          Unlock powerful features to create better quizzes and host bigger games
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {features.map((feature, index) => (
          <div
            key={index}
            className="relative group"
          >
            <div className="bg-gradient-to-br from-gray-50 to-white p-6 rounded-xl border border-gray-200 hover:border-purple-300 transition-all duration-300 hover:shadow-md">
              <div className="text-3xl mb-3">{feature.icon}</div>
              <h3 className="font-bold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-600 mb-4">{feature.description}</p>

              <div className="space-y-2">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-500">Free:</span>
                  <span className="text-gray-700">{feature.free}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-purple-600 font-medium">Pro:</span>
                  <span className="text-purple-700 font-semibold">{feature.pro}</span>
                </div>
              </div>
            </div>

            {/* Hover effect overlay */}
            <div className="absolute inset-0 bg-gradient-to-br from-purple-500/5 to-pink-500/5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
          </div>
        ))}
      </div>

      <div className="text-center">
        {/* Disabled during open beta
        <div className="bg-gray-50 rounded-lg p-6 mb-6 border border-gray-200">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="text-2xl">💎</span>
            <div>
              <p className="font-bold text-gray-900 text-lg">Ready to upgrade?</p>
              <p className="text-gray-600 text-sm">Join thousands of educators and professionals using QuizCrunch Pro</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <div className="flex gap-4">
              <div className="text-center">
                <div className="text-3xl font-bold text-gray-900">$35</div>
                <div className="text-sm text-gray-500">per year</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-gray-900">$4</div>
                <div className="text-sm text-gray-500">per month</div>
              </div>
            </div>
            <button
              onClick={() => navigate('/profile')}
              className="px-8 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors"
            >
              Upgrade to Pro
            </button>
          </div>
        </div>
        */}

        <p className="text-sm text-gray-600 font-medium">
          Pro features free in open beta
        </p>
      </div>
    </div>
  );
};

export default ProPlanTeaser;